import { useDialog } from "helper/customHook";
import ViewTable from "modules/DeclareLeave/components/CustomTable";
import {
  listEmployeeLeaveRequestSelector,
  totalRecordsEmployeeLeaveRequestSelector,
} from "modules/DeclareLeave/redux/selector";
import { useDispatch, useSelector } from "react-redux";

import { DIALOG } from "helper/enum/dialogEnum";

import EmptyState from "components/common/EmptyState";

import { useNavigate, useParams } from "react-router-dom";
import { declareLeaveURL } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent/index";
import { memo } from "react";

import pathRoutes from "routes/pathRoutes";
import useColumns from "./useColumn";
import LeaveRequestDetails from "../Modals/LeaveRequestDetail";
import { getListEmployeeLeaveRequestStart } from "modules/DeclareLeave/redux/getListEmployeeLeaveRequest";

export const ListLeaveRequest = memo(() => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { leaveCols: columns } = useColumns();
  const data = useSelector(listEmployeeLeaveRequestSelector);
  const totalRecords = useSelector(totalRecordsEmployeeLeaveRequestSelector);
  const requestLeaveDetailDialog = useDialog(
    DIALOG.EMPLOYEE_REQUEST_LEAVE_DETAIL
  );

  const navigate = useNavigate();

  const handleViewDetail = (idRecord: string) => {
    if (idRecord === id) {
      requestLeaveDetailDialog.open();
    } else {
      navigate(
        `${pathRoutes.declareLeave.base}/${declareLeaveURL.employeeOrderLeave}/${declareLeaveURL.leave}/${idRecord}`,
        {
          replace: true,
        }
      );
    }
  };

  return (
    <>
      <ViewTable
        id="employeeLeaveRequest"
        data={data || []}
        columns={columns}
        columnPinning={{
          left: [],
          right: ["action"],
        }}
        handleFetchMore={() => {
          dispatch(getListEmployeeLeaveRequestStart());
        }}
        messageEmpty={
          <EmptyState
            message="Chưa có đơn xin nghỉ nào"
            sx={(theme) => ({
              h6: {
                color: theme.palette.text.textSecondary,
              },
            })}
          />
        }
        handleOnClickedRow={(item) => {
          handleViewDetail(item.id);
        }}
        height={500}
        isHasMore={data?.length < totalRecords}
      />
      <LeaveRequestDetails />
    </>
  );
});
